import util from "./_util";
import comment from "./comment";
import fruit from "./fruit";
import organUpload from "./organUpload";
import myprivate from "./myprivate";
import update from "./update";
import user from "./user";
import wish from "./wish";
import publics from "./publics";

export default {
  ...util,
  ...comment,
  ...fruit,
  ...organUpload,
  ...myprivate,
  ...update,
  ...user,
  ...wish,
  ...publics,
};
